<template>
  <section
    class="barcode"
    id="automatic-order-to-case-conversion"
    v-loading="loading"
  >
    <el-row gutter="20">
      <el-col :lg="17" :xl="17">
        <div class="barcode__input">
          <img
            src="@/assets/images/blood-tube-animation.svg"
            alt="icon"
            class="blood-icon"
          />
          <el-input
            placeholder="Enter Barcode Details"
            :clearable="true"
            v-model="barcodeNumber"
            @input="getOrderDetails"
          ></el-input>
          <el-button
            class="automatic-barcode-btn"
            @click="getOrderDetails"
            :disabled="!this.barcodeNumber"
          >
            <img
              src="@/assets/images/automatic-barcode.svg"
              alt="icon"
              class="blood-icon"
            />
          </el-button>
        </div>
        <div class="barcode__detailsBlock" v-if="progressVisible">
          <div class="PatientCard">
            <div class="generateProgress">
              <el-progress
                :duration="5"
                :stroke-width="25"
                :percentage="100"
                :indeterminate="true"
                status="success"
              />
            </div>
          </div>
        </div>
        <div class="barcode__detailsBlock" v-if="automaticOrderDetails">
          <div class="PatientCard">
            <PatientCard></PatientCard>
          </div>
          <div
            class="barcode__detailsBlock"
            v-if="getScanOrderDetails && getScanOrderDetails.status != 'ACTIVE'"
          >
            <div class="PatientCard">
              <div class="generateSuccessText">
                <span>
                  ORDER STATUS
                  <span style="color: red">{{
                    getScanOrderDetails.status
                  }}</span>
                  CAN NOT PROCESS CREATE ACCESSION
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="barcode__detailsBlock" v-if="createAccessionStatus">
          <div class="PatientCard">
            <div class="generateSuccessText">
              <span>Accession ID Generated Successfully</span>
              <img
                src="@/assets/images/successIcon.svg"
                alt="icon"
                class="successIcon"
              />
            </div>
          </div>
        </div>
        <div class="barcode__detailsBlock" v-if="createAccessionStatus">
          <div class="PatientCard">
            <AccessionContainer></AccessionContainer>
          </div>
        </div>
        <div class="barcode__detailsBlock" v-if="successButton">
          <div class="PatientCard done-btn">
            <el-button class="success-btn" @click="clearFileds()"
              >Done</el-button
            >
          </div>
        </div>
      </el-col>
      <el-col :lg="7" :xl="7">
        <div class="barcode__activityContainer">
          <ActivityContainer></ActivityContainer>
        </div>
      </el-col>
    </el-row>
    <ExistingCaseDetails
      v-if="errorDiloag"
      :convert="convertToCase"
      :existedCase="existedCaseDetails"
      :existedOrder="exisistingOrderData"
      v-on:closePopupDialog="handlePopUp"
      :caseType="getScanOrderDetails.case_types"
      @approveCase="approveCase"
      :validationErrorMsg="validationError"
    >
    </ExistingCaseDetails>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
const PatientCard = defineAsyncComponent(() =>
  import("@/components/scanQrCode/PatientCard.vue")
);
const ActivityContainer = defineAsyncComponent(() =>
  import("@/components/scanQrCode/ActivityContainer.vue")
);
const AccessionContainer = defineAsyncComponent(() =>
  import("@/components/scanQrCode/AccessionContainer.vue")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
const ExistingCaseDetails = defineAsyncComponent(() =>
  import("@/components/cases/ExisistedCaseInfo")
);
export default {
  components: {
    PatientCard,
    ActivityContainer,
    AccessionContainer,
    ExistingCaseDetails,
  },
  data() {
    return {
      automaticOrderDetails: false,
      barcodeNumber: "",
      loading: false,
      progressVisible: false,
      createAccessionStatus: false,
      successButton: false,
      convertToCase: true,
      errorDiloag: false,
      existedCaseDetails: {},
      exisistingOrderData: {},
      specimenTypes: [],
      coriell_test_panels: [],
      medicalNecessities: [],
      allLabs: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup:[]
      },
      validationError: "",
    };
  },
  computed: {
    ...mapGetters("orders", [
      "getScanOrderDetails",
      "getAccessionCreationValidationErrors",
      "getAccessionCreateStatus",
      "getAccessionCreationValidationErrorCode",
      "getCreateAccessionDetails",
    ]),
  },
  async mounted() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
  methods: {
    async fetchScanLogs() {
      try {
        await this.$store.dispatch("orders/fetchScanOrderLogs");
      } catch (err) {
        console.log(err);
      }
    },
    async handlePopUp(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });
    },
    async approveCase(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear");
      const orderId = this.getScanOrderDetails._id;
      let params = this.prepreDataFromFormData();
      params.order = orderId;
      params.auto_approved = true;
      params.audit_type = "SCAN_ORDER";
      await this.$store.dispatch("orders/createAccessionForOrder", params);
      this.handleResponse();
    },
    getObjectByCaseType(testArray, caseType) {
      for (let i = 0; i < testArray.length; i++) {
        if (testArray[i].case_type === caseType) {
          return testArray[i];
        }
      }
      return [];
    },
    prepareTestInfoData() {
      if (
        this.getScanOrderDetails.case_types &&
        this.getScanOrderDetails.coriell_test_panels
      ) {
        this.coriell_test_panels.push(
          this.getObjectByCaseType(
            this.getScanOrderDetails.coriell_test_panels,
            this.getScanOrderDetails.case_types[0]
          )
        );
      }
      if (
        (this.getScanOrderDetails.case_types &&
          this.getScanOrderDetails.medical_necessities &&
          this,
        this.getScanOrderDetails.medical_necessities.length)
      ) {
        if (
          this.getObjectByCaseType(
            this.getScanOrderDetails.medical_necessities,
            this.getScanOrderDetails.case_types[0]
          ).length
        ) {
          this.medicalNecessities.push(
            this.getObjectByCaseType(
              this.getScanOrderDetails.medical_necessities,
              this.getScanOrderDetails.case_types[0]
            )
          );
        }
      }
      if (
        this.getScanOrderDetails &&
        this.getScanOrderDetails.sample_types &&
        this.getScanOrderDetails.case_types
      ) {
        const selectedSpecimen = this.getScanOrderDetails.sample_types.filter(
          (caseObj) =>
            caseObj.case_type === this.getScanOrderDetails.case_types[0]
        );
        this.specimenTypes = selectedSpecimen;
      }
    },
    prepreCaseDataFromFormData() {
      let collectionDate;
      if (
        this.getScanOrderDetails &&
        this.getScanOrderDetails.collection_date
      ) {
        collectionDate = this.convertLabUTCToClient(
          this.getScanOrderDetails.collection_date
        );
      }
      let params = {
        case_types: this.getScanOrderDetails.case_types[0],
        icd_10_codes: this.getScanOrderDetails.icd_10_codes,
        status: this.getScanOrderDetails.status,
        billing_status: this.getScanOrderDetails.billing_status,
        patient_order: this.getScanOrderDetails.patient_order,
        lab: this.getScanOrderDetails.lab._id,
        collection_date: this.convertToLabUTC(collectionDate),
        received_date: this.convertToLabUTC(new Date()),
        hospital: this.getScanOrderDetails.hospital
          ? this.getScanOrderDetails.hospital._id
          : null,
        ordering_physician: this.getScanOrderDetails.ordering_physician
          ? this.getScanOrderDetails.ordering_physician._id
          : null,
        referring_physician: this.getScanOrderDetails.referring_physician
          ? this.getScanOrderDetails.referring_physician._id
          : null,
        hospital_branch: this.getScanOrderDetails.hospital_branch
          ? this.getScanOrderDetails.hospital_branch._id
          : null,
        billing_type: this.getScanOrderDetails.billing_type,
        specimen_collector: this.getScanOrderDetails.specimen_collector,
        requisition_order_id: this.getScanOrderDetails.requisition_order_id,
        patient_info: { ...this.getScanOrderDetails.patient_info },
        covid_status: this.getScanOrderDetails.covid_status,
        test_results: this.getScanOrderDetails.test_results,
        test_reports: this.getScanOrderDetails.test_reports,
        attachments: this.getScanOrderDetails.attachments,
        internal_documents: this.getScanOrderDetails.internal_documents,
        internal_notes: this.getScanOrderDetails.internal_notes,
        coriell_test_panels:
          this.coriell_test_panels && this.coriell_test_panels.length
            ? this.coriell_test_panels
            : this.getScanOrderDetails.coriell_test_panels,
        specimen_types: this.getScanOrderDetails.specimen_types,
        billing_info: this.getScanOrderDetails.billing_info
          ? { ...this.getScanOrderDetails.billing_info }
          : undefined,
        sample_types:
          this.specimenTypes && this.specimenTypes.length
            ? this.specimenTypes
            : this.getScanOrderDetails.sample_types,
        toxicology_order_medical_necessity_fields:
          this.getScanOrderDetails.toxicology_order_medical_necessity_fields,
        urinalysis_order_medical_necessity_fields:
          this.getScanOrderDetails.urinalysis_order_medical_necessity_fields,
        urinary_tract_infectious_medical_necessity_fields:
          this.getScanOrderDetails
            .urinary_tract_infectious_medical_necessity_fields,

        signature_settings: this.getScanOrderDetails.signature_settings,
        order: this.$route.params.order_id,
      };
      if (
        this.getScanOrderDetails.medication &&
        this.getScanOrderDetails.medication.length
      ) {
        params.medication = this.getScanOrderDetails.medication;
      } else {
        params.medication = [];
      }

      if (
        this.getScanOrderDetails.case_types &&
        this.getScanOrderDetails.case_types.length
      ) {
        const casetypes = [
          "BLOOD_PANEL",
          "CGX_PANEL",
          "PULMONARY_PANEL",
          "PAD_ALZHEIMERS",
          "DIABETES",
          "CARDIAC",
          "PGX_TEST",
        ];
        const isPanelPresent = casetypes.includes(
          this.getScanOrderDetails.case_types[0]
        );

        if (isPanelPresent) {
          params.medical_necessities = [];
        } else {
          params.medical_necessities =
            this.medicalNecessities && this.medicalNecessities.length
              ? this.medicalNecessities
              : this.getScanOrderDetails.medical_necessities;
        }
      }
      if (
        this.getScanOrderDetails &&
        this.getScanOrderDetails.case_types &&
        this.getScanOrderDetails.tests_info
      ) {
        if (
          this.getScanOrderDetails.tests_info &&
          this.getScanOrderDetails.tests_info.length
        ) {
          params.tests_info = this.getScanOrderDetails.tests_info.map(
            (test) => test
          );
        } else {
          params.tests_info = [];
        }
      }
      if (
        this.getScanOrderDetails &&
        this.getScanOrderDetails.toxicology_ereq_form &&
        this.getScanOrderDetails.toxicology_ereq_form.length
      ) {
        params.toxicology_ereq_form =
          this.getScanOrderDetails.toxicology_ereq_form;
      }
      params.audit_type = "SCAN_ORDER";
      return params;
    },
    clearFileds() {
      this.barcodeNumber = "";
      this.automaticOrderDetails = false;
      this.createAccessionStatus = false;
      this.successButton = false;
    },
    prepreDataFromFormData() {
      let collectionDate;
      if (
        this.getScanOrderDetails &&
        this.getScanOrderDetails.collection_date
      ) {
        collectionDate = this.convertLabUTCToClient(
          this.getScanOrderDetails.collection_date
        );
      }
      return {
        lab: this.getScanOrderDetails.lab._id,
        collection_date: this.convertToLabUTC(collectionDate),
        received_date: this.convertToLabUTC(new Date()),
        marketer_details: this.getScanOrderDetails.marketer_details
          ? this.getScanOrderDetails.marketer_details
          : undefined,
        specimen_collector: this.getScanOrderDetails.specimen_collector
          ? this.getScanOrderDetails.specimen_collector
          : undefined,
        case_types: this.getScanOrderDetails.case_types
          ? this.getScanOrderDetails.case_types
          : undefined,
      };
    },
    async sumbitCaseInformation() {
      try {
        const orderId = this.getScanOrderDetails._id;
        let params = this.prepreDataFromFormData();
        params.order = orderId;
        params.audit_type = "SCAN_ORDER";
        await this.$store.dispatch("orders/createAccessionForOrder", params);
        this.handleResponse();
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: "Erorr while creating acccession",
        });
      }
    },
    handleResponse() {
      if (this.getAccessionCreateStatus) {
        this.progressVisible = false;
        this.progressVisible = false;
        this.createAccessionStatus = true;
        this.successButton = true;
        successNotification("Accession created successfully");
        this.fetchScanLogs();
      } else if (
        this.getAccessionCreationValidationErrorCode.error_code ===
          "GENETIC_TEST_EXISTED" ||
        this.getAccessionCreationValidationErrorCode.error_code ===
          "TEST_ALREADY_EXISTED" ||
        this.getAccessionCreationValidationErrorCode.error_code ===
          "NON_GENTIC_TEST_VALIDATE" ||
        this.getAccessionCreationValidationErrorCode.error_code ===
          "DUPLICATE_EXISTED"
      ) {
        this.progressVisible = false;
        this.errorDiloag = true;
        this.validationError =
          this.getAccessionCreationValidationErrorCode.error_code;
        if (
          this.getScanOrderDetails &&
          this.getScanOrderDetails.case_types &&
          this.getScanOrderDetails.case_types.length > 1
        ) {
          this.prepareTestInfoData();
        }
        if (
          this.getAccessionCreationValidationErrorCode.errors &&
          this.getAccessionCreationValidationErrorCode.errors.existed_details
        )
          this.existedCaseDetails =
            this.getAccessionCreationValidationErrorCode.errors.existed_details;

        this.exisistingOrderData = this.prepreCaseDataFromFormData();
        if (
          this.getScanOrderDetails &&
          this.getScanOrderDetails.physician_notes
        ) {
          this.exisistingOrderData.physician_notes =
            this.getScanOrderDetails.physician_notes;
        }
      } else if (!this.getAccessionCreationValidationErrors) {
        this.progressVisible = false;
        this.barcodeNumber = "";
        this.$notify.error({
          title: "Error",
          message: "Erorr while creating acccession",
        });
      } else {
        this.progressVisible = false;
        this.barcodeNumber = "";
        this.$notify.error({
          title: "Error",
          message: "Erorr while creating acccession",
        });
      }
    },
    async getOrderDetails() {
      try {
        let params = {
          orderId: this.barcodeNumber.trim(),
        };
        await this.$store.dispatch("orders/fetchScanOrderById", params);
        if (
          this.getScanOrderDetails &&
          this.getScanOrderDetails != null &&
          this.getScanOrderDetails.status &&
          this.getScanOrderDetails.status == "ACTIVE"
        ) {
          this.progressVisible = true;
          this.automaticOrderDetails = true;
          if (this.getScanOrderDetails && this.getScanOrderDetails.tests_info) {
            this.panelsTestsData.selectedTestIds =
              this.getScanOrderDetails.tests_info.map((el) => el._id);
          }
          if (
            this.getScanOrderDetails.coriell_test_panels &&
            this.getScanOrderDetails.coriell_test_panels.length
          ) {
            this.panelsTestsData.selectedCoriellPanels =
              this.getScanOrderDetails.coriell_test_panels;
          }
          successNotification("Order details fetched successfully");
          setTimeout(() => {
            // this.progressVisible = false;
            this.sumbitCaseInformation();
          }, 5000);
        } else if (
          this.getScanOrderDetails &&
          this.getScanOrderDetails != null &&
          this.getScanOrderDetails.status
        ) {
          this.automaticOrderDetails = false;
          this.barcodeNumber = "";
          if (
            this.getScanOrderDetails &&
            this.getScanOrderDetails.status == "COMPLETE"
          ) {
            this.automaticOrderDetails = true;
          }
          if (
            this.getScanOrderDetails &&
            this.getScanOrderDetails.status == "PENDING"
          ) {
            this.automaticOrderDetails = true;
          }
          if (
            this.getScanOrderDetails &&
            this.getScanOrderDetails.status == "REJECTED"
          ) {
            this.automaticOrderDetails = true;
          }
          if (
            this.getScanOrderDetails &&
            this.getScanOrderDetails.status == "PARTIAL"
          ) {
            this.automaticOrderDetails = true;
          }
        } else {
          this.barcodeNumber = "";
          this.automaticOrderDetails = false;
          errorNotification("Order details not existed");
        }
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
  },
};
</script>

<style lang="scss">
.barcode {
  padding: 1.5rem 2rem;
  &__input {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 10px;
    .el-input {
      width: 250px;
    }
    .el-input__inner {
      border: 1px solid #215fad;
      border-radius: 8px;
      height: 34px;
    }
    .blood-icon {
      height: 30px;
      width: 30px;
    }
    .automatic-barcode-btn {
      padding: 0;
      border: none;
      min-height: 30px;
      background-color: transparent;
      position: relative;
      top: 2px;
      .blood-icon {
        height: 32px;
        width: 32px;
      }
    }
  }
  &__detailsBlock {
    .PatientCard {
      width: 80%;
      margin: auto;
      margin-top: 20px;
      @media (min-width: 1300px) and (max-width: 1500px) {
        width: 92%;
      }
      .detailsMainBlock {
        background: #ffffff;
        border: 1.2px solid #e7e7f7;
        border-radius: 6.40567px;
        padding: 20px;
        .subHeader {
          display: flex;
          align-items: center;
          column-gap: 5px;
          .title {
            font-size: 20px;
            font-weight: 400;
            color: #1b2459;
          }
          .patient-icon {
            width: 24px;
            height: 24px;
          }
        }

        .patientDetails {
          padding: 10px 5px;

          .input-value {
            .name {
              font-size: 13px;
              text-transform: uppercase;
              color: #828282;
              font-weight: 400;
              display: block;
              margin-bottom: 3px;
              letter-spacing: 0.25px;
            }
            .value {
              color: #0a2342;
              font-size: 16px;
              font-weight: 500;
              line-height: 20px;
              overflow-wrap: break-word;
              letter-spacing: 0.25px;

              .time {
                color: #215fad;
                font-size: 14px;
                padding-left: 3px;
              }
            }
            .specialValue {
              color: #215fad;
              font-size: 24px;
              margin-top: 5px;
              font-weight: 500;
              line-height: 20px;
              overflow-wrap: break-word;
              letter-spacing: 0.25px;
            }
            ul {
              li {
                padding: 3px 10px;
                border: none;
                max-width: fit-content;
                margin: 3px 0;
                background: rgba(224, 224, 224, 0.4);
                font-size: 13px;
                border-radius: 20px;
                color: #0a5da6;
              }
            }
          }
        }
      }
      &.existingPatient {
        .existingHeader {
          h3 {
            background-color: #1b2459;
            color: #ffffff;
            width: max-content;
            padding: 5px;
            border-radius: 15px 0 0 0;
            position: relative;
            right: 20px;
            bottom: 20px;
          }
        }
      }
      .generateSuccessText {
        color: #4bb453;
        display: flex;
        align-items: center;
        column-gap: 10px;
        justify-content: center;
      }
      &.done-btn {
        text-align: end;
        .success-btn {
          color: #ffffff;
          background-color: #4bb453;
          line-height: 10px;
          height: 36px;
          min-height: 36px;
          border-radius: 10px;
          border: none;
          &:hover,
          &:focus {
            background-color: #4bb453;
            color: #ffffff;
          }
        }
      }
    }
  }
  &__activityContainer {
    background: #ffffff;
    border-radius: 4px;
    height: calc(100vh - 135px);
    overflow: hidden;
    .automaticOrdersActivities {
      .activityHeader {
        border-bottom: 1.2px solid #e7e7f7;
        h3 {
          padding: 10px 20px;
          color: #000000;
          font-weight: 500;
          font-size: 17px;
          letter-spacing: 0;
          text-transform: uppercase;
        }
      }
      .listOfActivities {
        padding: 10px 10px 10px 20px;
        .activitiesLists {
          height: calc(100vh - 250px);
          overflow: auto;

          .eachList {
            padding-bottom: 10px;
            .accessionId {
              display: flex;
              align-items: center;
              column-gap: 10px;
              h4 {
                color: #1b2459;
                font-weight: 500;
                font-size: 16px;
              }
            }
            .reasonDes {
              color: #000000;
              font-weight: 400;
              font-size: 14px;
            }
            .activityTime {
              color: #828282;
              font-weight: 400;
              font-size: 14px;
              margin-top: 3px;
            }
          }
        }
        .listOfActivitiesPaginations {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #215fad;
          border-radius: 10px;
          overflow: hidden;
          padding: 3px;
          margin-top: 10px;

          .el-pagination__jump {
            margin-left: 5px;
          }
          .el-pagination .btn-prev {
            padding-right: 5px;
          }
          .el-pagination .btn-next {
            padding-left: 5px;
          }
          .el-pagination .el-select .el-input {
            width: 85px;
            margin: 0 5px;
          }
          .el-pagination__total {
            margin-right: 20px;
          }
          .el-pagination__jump {
            display: none;
          }
          .el-pagination__sizes .el-input .el-input__inner {
            border-color: #828282;
            border-radius: 7px;
          }
          .el-select__caret {
            color: #000000 !important;
            font-weight: 900 !important;
          }
        }
      }
    }
  }
  .generateProgress {
    .el-progress-bar__outer {
      width: 75%;
      margin-top: 20px !important;
      margin: auto;
    }
    .el-progress.is-success .el-progress-bar__inner {
      background: linear-gradient(90.15deg, #273480 0.11%, #bf1b39 100.62%);
    }
    .el-progress.is-exception .el-progress-bar__inner {
      background: linear-gradient(90.15deg, #273480 0.11%, #bf1b39 100.62%);
    }
    .el-progress-bar__outer {
      background-color: #ffffff;
      border-radius: 7px;
    }
    .el-progress__text i {
      margin-top: 20px;
    }
  }
  .addApprovalBtn {
    text-align: end;
    .btn {
      padding: 14px;
      color: #ffffff;
      margin-top: 0.8rem;
      font-size: 16px;
      font-weight: 400;
      background-color: #bf1b39;
      border: none;
      border-radius: 5px;
      &:hover,
      &:active,
      &:focus {
        background-color: #bf1b39;
        color: #ffffff;
      }
    }
  }
}
</style>
